<template>
  <div class="t-tab-manager">
    <div ref="manager">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 't-tab-content-manager',
  props: {
    actived: { type: String, default: 'Tab Actived' },
  },
  methods: {
    disableAllContents() {
      [...this.$refs.manager.children].map((el) => {
        el.style.display = 'none';
      });
    },
    enableActivedTab() {
      this.disableAllContents();
      const index = this.actived;
      const { manager } = this.$refs;
      const activedTab = manager.querySelector(`[index="${index}"]`);
      if (activedTab) activedTab.style.display = 'block';
    },
  },
  watch: {
    actived() {
      this.enableActivedTab();
    },
  },
  mounted() {
    this.enableActivedTab();
  },
};
</script>

<style lang="scss" scoped>
.t-tab-manager {
  flex: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
